import { useSelection } from "@/contexts/SelectionContext";
import { useDeleteLessons } from "@/lib/hooks/lessons/useDeleteLessons";
import { useDeleteProjects } from "@/lib/hooks/projects/useDeleteProjects";
import { Button, IconButton } from "@ai-teach/ui-web";
import { HiX } from "react-icons/hi";
import { MdDelete, MdRestore } from "react-icons/md";

interface SelectionActionModalProps {
  page: "projectTrashPage" | "lessonTrashPage";
}

export function TrashSelectionActionModal({ page }: SelectionActionModalProps) {
  const {
    selectedLessonIds,
    selectedProjectIds,
    selectedSlideIds,
    clearAllSelections,
    toggleDeleteModal,
    toggleRestoreModal,
    toggleIsSelectionMode,
  } = useSelection();

  const isProjectPage = page === "projectTrashPage";

  const selectedItemsCount = isProjectPage
    ? selectedLessonIds.length + selectedProjectIds.length
    : selectedSlideIds.length;

  const { loading: projectDeleteLoading } = useDeleteProjects();
  const { loading: lessonDeleteLoading } = useDeleteLessons();

  const isLoading = lessonDeleteLoading || projectDeleteLoading;

  if (selectedItemsCount === 0) return;

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-surface rounded-lg shadow-2xl border border-gray-700 px-6 py-4">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-secondary-200">{selectedItemsCount} selected</span>
          </div>
          <div className="flex items-center gap-3 border-l border-gray-700 pl-6">
            <Button
              variant="secondary"
              size="sm"
              onClick={() =>
                isProjectPage ? toggleRestoreModal("Items") : toggleRestoreModal("Slides")
              }
              className="flex items-center gap-2 group"
              disabled={selectedItemsCount === 0}
            >
              <MdRestore className="text-xl group-hover:rotate-[-30deg] transition-transform duration-200" />
              Restore
            </Button>
            <Button
              variant="danger"
              size="sm"
              onClick={() => toggleDeleteModal(true)}
              className="flex items-center gap-2"
              disabled={isLoading || selectedItemsCount === 0}
            >
              <MdDelete className="w-4 h-4" />
              Delete
            </Button>
          </div>
          <IconButton
            onClick={() => {
              clearAllSelections();
              toggleIsSelectionMode(false);
            }}
            variant="ghost"
            shape="circle"
            aria-label="Close selection"
          >
            <HiX className="w-5 h-5" />
          </IconButton>
        </div>
      </div>
    </div>
  );
}
